enum KeyCode {
  ENTER = "Enter"
}

export default KeyCode;
